import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'frodo-logo',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
  @Input() alt: string;
  @Input() text = 'common.poweredBy';
  @Input() textPosition: 'top' | 'left' = 'left';
  @Input() showTitle = false;
  @Input() src: string;
}
